import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";

const useGetTrialGeneralNotificationConfig = ({ trialId, enabled = true }) => {
  const token = localStorage.getItem("token");

  return useQuery({
    queryKey: ["trial_general_notification_config", trialId],
    queryFn: async () => {
      const res = await axios.get(
        `${__API_URL__}/api/appointments/trial_general_notification_config/${trialId}/`,
        { headers: { Authorization: `Token ${token}` } }
      );
      return res.data;
    },
    enabled: enabled && Boolean(trialId),
    refetchOnWindowFocus: false,
  });
};

export default useGetTrialGeneralNotificationConfig;
